import NavBar from "./NavBar";

export default function Footer() {
  return (
    <footer>
      <NavBar type="footer" />
      <h6 className="trademark">The Glascock™ - 2021</h6>
    </footer>
  );
}
